/*
 * filter.js 26.01.18
 *
 * (c) 2018 ergovia GmbH
 */
import { ACTIVE_FILTER, FILTER_NONE } from '../actions/types';

const activeFilter = (state = FILTER_NONE, action) => {

    switch (action.type) {

        case ACTIVE_FILTER:
            return action.filter;

        default:
            return state;

    }

};

export default activeFilter;



// WEBPACK FOOTER //
// ./src/de/ergovia/reducers/filter.js